<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li">
                <div class="form__ttl">주소</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="text" placeholder="" v-model="params.companyAddress1" disabled>
                    </label>
                    <button class="btn type_02" @click="fnSearch">검색</button> <!--노란색 버튼은 type_02-->
                  </div>
                  <div class="inline">
                    <label class="input">
                      <input type="text" placeholder="상세 주소 입력" v-model="params.companyAddress2">
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm" :class="{'on':isPossibleSave}" @click="fnSave">변경하기</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>
import {required} from 'vuelidate/lib/validators'
export default {
  data: function () {
    return {
      isShow: false,
      params: {
        userNo: this.$store.getters['account/getUserData'].userNo,
        companyAddress1: this.$store.getters['account/getUserData'].companyAddress1,
        companyAddress2: this.$store.getters['account/getUserData'].companyAddress2
      },
    }
  },
  validations: {
    params: {
      companyAddress1: {
        required
      },
      companyAddress2: {
        required
      }
    }
  },
  computed: {
    isPossibleSave : function () {
      if((this.params.companyAddress1 !== '' && !this.$v.params.companyAddress1.$error) &&
        (this.params.companyAddress2 !== '' && !this.$v.params.companyAddress2.$error)) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    fnSearch: function () {
      const _this = this
      this.$store.commit('layout/setModal', {
        modalName: 'address-modal', data: {title: '주소 검색'}, callBack: function (item) {
          setTimeout(function () {
            _this.fnBindAddress(item)
          }, 200)
        }
      })
    },
    fnBindAddress: function(item) {
      this.params.companyAddress1 = item.roadAddress
    },
    fnSave: function() {
      if (!this.$Util.isValid(this.$v, this.$el)) return false
      this.$AccountSvc.modifyCompanyAddress(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            const _this = this
            this.$Util.modalAlert({message: '변경 되었습니다.'}, function () {
              setTimeout(function () {
                _this.$Util.refreshUserData(function () {
                  _this.$router.go(-1)
                })
              }, 200)
            })
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    }
  }
}
</script>
